import React from 'react';
import { SSpinner } from '@chargebee/sting-react';
import { CBRetentionLogo } from '@bbkAdminComponents/cbretention-logo';
import { BrandIcons } from '@bbkAdminUtils/brand-icons';
import { cs } from '@bbkAdminUtils/css-utils';
import { useBodyScrollMode } from '@bbkAdminUtils/use-body-scroll-mode';

export const PreparingOverlay: React.FC<{
  message?: string;
  presentation?: 'legacy' | 'sting';
}> = ({ message, presentation = 'legacy' }) => {
  useBodyScrollMode('lock');

  if (presentation === 'sting') {
    return (
      <div className="tw-fixed tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-neutral-50">
        <div className="tw-flex tw-max-w-sm tw-flex-col tw-items-center tw-px-8 tw-py-12 tw-text-center">
          <CBRetentionLogo className="tw-mb-12 tw-h-8 tw-w-auto" />
          <SSpinner
            size="large"
            className="tw-mb-6 tw-shrink-0 [&_circle]:!tw-fill-none [&_svg]:!tw-m-0 [&_svg]:!tw-block"
          />
          <p className="tw-mb-2 tw-text-lg tw-font-semibold tw-text-neutral-900">
            {message || 'Preparing your workspace'}
          </p>
          <p className="tw-mb-0 tw-text-sm tw-text-neutral-600">
            Please keep this page open.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="tw-absolute tw-h-screen tw-overflow-hidden">
      <div
        className={cs(
          'tw-h-full tw-w-full',
          'tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-10',
          'tw-flex tw-flex-col tw-items-center tw-justify-center',
          'tw-bg-white tw-text-sm tw-font-medium tw-text-primary-900'
        )}
      >
        <div className="tw-text-center">
          <div
            className={cs(
              'tw-inline-block tw-w-2/3 tw-text-cblogo',
              'tw-animate-[beat_3s_ease-in-out_infinite]'
            )}
          >
            {BrandIcons.cbRetentionPulse}
          </div>
        </div>
        <div
          className={cs(
            'tw-w-full tw-text-center',
            // invisible before needed to balance the visible after:content
            // so when Loading... is rendered it would stay in the same place on the screen
            'before:tw-invisible before:tw-animate-[ellipsis_3s_ease-in-out_infinite]',
            'after:tw-animate-[ellipsis_3s_ease-in-out_infinite]'
          )}
        >
          {message || 'Preparing your workspace'}
        </div>
      </div>
    </div>
  );
};
